import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCustomerCreditCards, deleteCustomerCreditCard, saveButtonDisable, deleteSelectedCreditCard } from '../../actions/PaymentAction';
import { StripeProvider, Elements } from 'react-stripe-elements';
import { ClipLoader } from 'react-spinners';
import { css } from 'emotion';
import StripeCardForm from '../../components/StripeCardForm';
import { qpOpenModal } from '../../utils/misc';
import swal from 'sweetalert';

const override = css`
    display: block;
    border-color: red;
`;

class PaymentOptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cards: [],
            isLoading: false,
            token: "",
            customerId: 0,
            selectedCard: null,
            selectCardName: '',
            deleteButtonDivDisable: false,
            checkedItems: new Map(),
            cardListToDelete: [],
            isChecked: false,
        };
    }
    componentDidMount() {

        this.props.getCustomerCreditCards().then(result => {
            if (result.cards !== null && result.cards.length > 0) {
                this.setState({ cards: result.cards, customerId: result.customerId })
            }
        })
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.cards !== this.state.cards) {
            this.setState({
                cards: nextProps.cards
            })
        }

        if (nextProps.cards || []) {
            this.setState({
                deleteButtonDivDisable: false,
                isChecked: false
            })
        }
    }

    handleChange = (e) => {

        const item = e.target.name;
        const isChecked = e.target.checked;

        let checkedCount = 0;

        this.setState({ checkedItems: this.state.checkedItems.set(item, isChecked), deleteButtonDivDisable: true });

        (this.props.cards || []).map((card, index) => {
            if (this.state.checkedItems.get(card.id) === true) {
                checkedCount++
            }
        })

        if (checkedCount === 0) {
            this.setState({
                deleteButtonDivDisable: false
            })
        }
    }

    selectAllCard = (e) => {

        const isChecked = e.target.checked;

        if (isChecked) {

            (this.props.cards || []).map((card, index) => {
                this.setState({ checkedItems: this.state.checkedItems.set(card.id, true), deleteButtonDivDisable: true, isChecked: true });
            })
        } else {

            (this.props.cards || []).map((card, index) => {
                this.setState({ checkedItems: this.state.checkedItems.set(card.id, false), deleteButtonDivDisable: false, isChecked: false });
            })
        }
    }

    _deleteTableCard = () => {

        swal({
            title: "Are you sure?",
            text: "Credit Card Will Be Deleted!",
            icon: "warning",
            buttons: {
                cancel: true,
                Ok: {
                    text: "OK",
                    value: "ok",
                    closeModal: false
                }
            },
        }).then((value) => {
            if (value === 'ok') {

                this.state.cardListToDelete.length = 0;

                (this.state.cards || []).map((card, index) => {
                    if (this.state.checkedItems.get(card.id) === true) {
                        this.state.cardListToDelete.push({ cardId: card.id, customerId: this.state.customerId })
                    }
                })

                this.props.deleteSelectedCreditCard(this.state.cardListToDelete).then(() => {

                    swal.close();

                    this.props.getCustomerCreditCards();

                    this.setState({
                        deleteButtonDivDisable: false
                    })
                })
            }
        });

    }

    _editCard(selected) {
        this.setState({
            selectedCard: selected,
            selectCardName: 'edit'
        }, () => {

            this.props.saveButtonDisable();
            qpOpenModal("#AddCardModal")
        });
    }

    removeModalData() {
        this.setState({ ShowComponent: false, ShowComponentPDF: false });
    }

    _deleteCard(token, customerId) {

        swal({
            title: "Are you sure?",
            text: "Credit Card Will Be Deleted!",
            icon: "warning",
            buttons: {
                cancel: true,
                Ok: {
                    text: "OK",
                    value: "ok",
                    closeModal: false
                }
            },
        }).then((value) => {
            if (value === 'ok') {

                this.props.deleteCustomerCreditCard(token, customerId).then(() => {

                    swal.close();

                    this.props.getCustomerCreditCards()
                });
            }
        });

    }

    _addCard() {
        this.setState({
            selectCardName: 'add'
        }, () => {
            this.props.saveButtonDisable();
            qpOpenModal("#AddCardModal")
        });
    }

    render() {

        return (
            <main className="main-content col-lg-6 offset-lg-3" role="main">
                <div className="row">
                    <div className="col-md-12">
                        <h1><button data-toggle="modal" className="btn btn-primary btn-sm pull-right" onClick={() => this._addCard()}><i className="batch-icon batch-icon-credit-card-alt" /> Add Card</button></h1>
                    </div>
                </div>
                <div className="col-lg-12" style={{ padding: "0px", margin: "0px" }}>
                    <div className="card">
                        <div className="card-header" style={{ borderBottom: "0px" }}>
                            <div className="col-lg-7" style={{ float: "left" }}>
                                Saved Cards
                            </div>
                            <div className="col-lg-5" style={{ float: "left", display: this.state.deleteButtonDivDisable ? "block" : "none" }} >
                                <button data-toggle="modal" className="btn btn-danger btn-sm pull-right" onClick={() => this._deleteTableCard()}><i className="batch-icon batch-icon-delete" />Delete</button>
                            </div>
                        </div>

                        {this.props.isLoading ?
                            <div className="card-table table-responsive" style={{ textAlign: 'center' }}>
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={150}
                                    color={'rgb(54, 215, 183)'}
                                    loading={true}
                                />
                            </div> :
                            this.state.cards !== null && this.state.cards.length === 0 ?
                                <div className="card-table table-responsive" style={{ textAlign: 'center', padding: 10 }}>
                                    No Registered Credit Card Found. Please Add Credit Card.
                                </div> :
                                <table className="table table-hover table-sm align-middle">
                                    <thead style={{ borderTop: "1px solid rgba(0, 0, 0, 0.09)" }}>
                                        <tr>
                                            <th className="text-center">

                                                <div className="custom-control custom-checkbox" style={{ margin: "0px auto", width: "0px" }}>

                                                    <input type="checkbox"
                                                        className="custom-control-input"
                                                        id="checkbox-all"
                                                        checked={this.state.isChecked}
                                                        onChange={this.selectAllCard}
                                                    />

                                                    <label className="custom-control-label" htmlFor="checkbox-all"></label>
                                                </div>


                                            </th>
                                            <th className="text-center">Last4</th>
                                            <th className="text-center">Exp.Date</th>
                                            <th className="text-center">Brand</th>
                                            <th className="text-center">Action </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(this.state.cards || []).map((card, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className="text-center">

                                                        <div className="custom-control custom-checkbox" style={{ margin: "0 auto", width: "0px" }}>

                                                            <input type="checkbox"
                                                                className="custom-control-input"
                                                                name={card.id}
                                                                id={index}
                                                                onChange={this.handleChange}
                                                                checked={this.state.checkedItems.get(card.id) === undefined ?
                                                                    false : this.state.checkedItems.get(card.id)} />

                                                            <label className="custom-control-label" htmlFor={index}></label>
                                                        </div>

                                                    </td>
                                                    <td className="text-center">{card.last4}</td>
                                                    <td className="text-center">{card.exp_month + "/" + card.exp_year}</td>
                                                    <td className="text-center">{card.brand}</td>
                                                    <td className="text-center">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link"
                                                            data-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                            data-flip="false"
                                                        >
                                                            <i className="batch-icon batch-icon-ellipsis"></i>
                                                        </button>
                                                        <div
                                                            className="dropdown-menu dropdown-menu-right"
                                                            aria-labelledby="reply-mail-dropdown"
                                                            style={{ top: 0, left: 0 }}>
                                                            <a className="dropdown-item" onClick={() => this._editCard(card)}>
                                                                <i className="batch-icon batch-icon-pencil" />
                                                                Edit Card
                                                            </a>
                                                            <a className="dropdown-item" onClick={() => this._deleteCard(card.id, this.state.customerId)}>
                                                                <i className="batch-icon batch-icon-delete" />
                                                                Delete Card
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                        }
                    </div>
                </div>
                <div
                    className="modal fade"
                    id="AddCardModal"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="myLargeModalLabel"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content col-lg-8 offset-lg-2">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel"> {this.state.selectCardName === "edit" ? "Edit Card" : "Add New Card"} </h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => this.removeModalData()}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12 mb-5">
                                        <div className="card">
                                            <div className="card-body">
                                                {
                                                    this.props.stripePK === null ? null :
                                                        <StripeProvider apiKey={this.props.stripePK}>
                                                            <div>
                                                                <Elements>
                                                                    <StripeCardForm card={this.state.selectedCard} />
                                                                </Elements>
                                                            </div>
                                                        </StripeProvider>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal"> Close </button>
                            </div>
                        </div>
                    </div>
                </div>
            </main >
        );
    }
}


const mapStateToProps = state => {
    return {
        cards: state.paymentData.cards,
        stripePK: state.paymentData.stripePK,
        isLoading: state.paymentData.isLoading
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getCustomerCreditCards: () => dispatch(getCustomerCreditCards()),
        deleteCustomerCreditCard: (token, customerId) => dispatch(deleteCustomerCreditCard(token, customerId)),
        saveButtonDisable: () => dispatch(saveButtonDisable()),
        deleteSelectedCreditCard: (creditCards) => dispatch(deleteSelectedCreditCard(creditCards))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(PaymentOptions);




// WEBPACK FOOTER //
// ./src/view/PaymentOptions/PaymentOptions.js